import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const infoCards = [
    {
      icon: '📍',
      title: 'Visit Us',
      content: ['8 Van Riebeeck', 'Groblersdal', 'Limpopo', '0470']
    },
    {
    icon: '📞',
    title: 'Call Us',
    content: ['Phone: +27832391619'],
    link: 'tel:+27832391619'
    },
    {
      icon: '⏰',
      title: 'Opening Hours',
      content: ['Monday - Friday: 9:00 AM - 5:00 PM', 'Saturday: 09:00 AM - 2:00 PM']
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setShowSuccess(true);
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setShowSuccess(false);
    }, 5000);
  };

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-subtitle">We'd love to hear from you</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2 className="content-title">Contact Information</h2>
              <p className="contact-intro">Have a question, suggestion, or just want to say hi? We're here for you!</p>
              
              <div className="info-cards">
                {infoCards.map((card, index) => (
                  <div key={index} className="info-card">
                    <div className="info-icon">{card.icon}</div>
                    <div>
                     <h3>{card.title}</h3>
          {card.link ? (
  <a href={card.link} style={{ color: 'inherit', textDecoration: 'none' }}>
    {card.content[0]}
  </a>
            ) : (
              <p>
             {card.content.map((line, i) => (
            <React.Fragment key={i}>
             {line}
              {i < card.content.length - 1 && <br />}
            </React.Fragment>
            ))}
            </p>
              )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="contact-form-container">
              <h2 className="content-title">Send Us a Message</h2>
              {!showSuccess ? (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      placeholder="John Doe"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                  
                  
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="+27 --- ----"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Subject</label>
                    <select
                      id="subject"
                      name="subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      style={{ color: 'black' }}
                    >
                      <option value="" style={{ color: 'black' }}>Select a subject</option>
                      <option value="general" style={{ color: 'black' }}>General Inquiry</option>
                      <option value="feedback" style={{ color: 'black' }}>Feedback</option>
                      <option value="suggestion" style={{ color: 'black' }}>Product Suggestion</option>
                      <option value="other" style={{ color: 'black' }}>Other</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      required
                      placeholder="Tell us what's on your mind..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  
                  <button type="submit" className="submit-button">
                    <span>Send Message</span>
                    <span className="button-glow"></span>
                  </button>
                </form>
              ) : (
                <div className="form-success show">
                  <div className="success-icon">✓</div>
                  <p>Thank you! Your message has been sent successfully.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <h2 className="content-title centered">Find Us</h2>
          <div className="map-placeholder">
            <div className="map-icon">🗺️ Sweet &amp; Snack</div>
            {/* Responsive map wrapper */}
            <div style={{
              position: 'relative',
              width: '100%',
              paddingBottom: '56.25%', /* 16:9 aspect ratio */
              height: 0,
              overflow: 'hidden',
              borderRadius: '12px',
              marginTop: '1rem'
            }}>
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2816.4573561089455!2d29.397405074284766!3d-25.166645122521658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ec035238ef83d89%3A0xe7547d6176f8727e!2sSweet%20and%20Snack%20World!5e1!3m2!1sen!2sza!4v1777719674095!5m2!1sen!2sza"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 0
                }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;